import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalAjudaComponent } from './modal-ajuda/modal-ajuda.component';

@Injectable({
  providedIn: 'root'
})
export class ModalAjudaService {
  constructor(private modalService: BsModalService) {}

  mostrar(itens: any, texto: string) {
    const bsModalRef: BsModalRef = this.modalService.show(
      ModalAjudaComponent,
      Object.assign({}, { class: 'max-content' })
    );
    bsModalRef.setClass('max-content');
    bsModalRef.content.itens = itens;
    bsModalRef.content.texto = texto;
  }
}
